<template>
    <div>
        <!-- Modal 提示框 -->
        <a-modal
                v-model="isModalVisible"
                :title="$t('pubGicSet.SelectSKU')"
                @cancel="handleCancel"
                @ok="handleOk"
                :okText="$t('publicLang.Confirm')"
                :cancelText="$t('publicLang.Cancel')"
        >
<!--            <p>请选择一个 SKU：</p>-->
            <br/>
            <!-- 显示所有 SKU 列表 -->
            <a-radio-group v-model="selectedSku"  class="sku-radio-group">
                <a-radio v-for="sku in skuList" :key="sku" :value="sku">{{ sku }}</a-radio>
            </a-radio-group>
            <br/>
        </a-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // 控制 Modal 是否可见
                isModalVisible: false,
                // SKU 列表
                skuList:  [],
                // 当前选择的 SKU
                selectedSku: null
            };
        },
        methods: {
            // 显示 Modal
            showModal(selectSkuList) {
                this.skuList = selectSkuList;
                this.isModalVisible = true;
            },
            // 取消按钮的处理
            handleCancel() {
                this.isModalVisible = false;
                this.selectedSku = null;
            },
            // 提交按钮的处理
            handleOk() {
                if (this.selectedSku) {
                    // this.$message.success(`您选择了 ${this.selectedSku}`);
                    this.$emit('selectSku', this.selectedSku);
                    this.isModalVisible = false;
                    this.selectedSku = null;
                } else {
                    this.$customMessage.error(this.$t('pubGicSet.SelectOneSKU'));
                }
            }
        }
    };
</script>

<style scoped>
    /*.sku-radio-group {*/
    /*    display: flex;*/
    /*    !*flex-direction: column;*!*/
    /*    align-items: center; !* 使单选框在水平方向上居中对齐 *!*/
    /*    justify-content: center; !* 使单选框在垂直方向上居中对齐 *!*/
    /*    text-align: center; !* 让文本内容居中 *!*/
    /*}*/
    .sku-radio-group {
        display: flex;
        flex-wrap: wrap; /* 启用换行 */
        justify-content: center; /* 保证从左到右排列 */
        gap: 10px; /* 选项之间的间隔 */
    }
    /* 你可以根据需要添加样式 */
    .sku-radio-group .ant-radio-wrapper {
        display: inline-block; /* 让每个单选框以块级元素方式排列 */
        margin-bottom: 10px; /* 为了确保换行时保持间距 */
    }
</style>
